<template>
  <div class="main-content">
    <div class="container-fluid">
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary" @click="openAddUserDialog()">
          Aggiungi utente
        </button>
      </div>
      <b-table striped hover :items="items" :fields="fields" :busy="loading">
        <!-- <template #cell(actions)="row">
          <i
            class="fas fa-edit cursor-pointer"
            @click="openEditDialog(row)"
          ></i>
        </template> -->

        <template #table-busy>
          <div class="text-center text-secondary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </div>

    <AddUserDialog @add="handleAddedUser()" />
  </div>
</template>

<script>
import UsersService from "@/services/users";

export default {
  data() {
    return {
      fields: [
        {
          key: "utente",
          sortable: false,
        },
        {
          key: "email",
          sortable: false,
        },
        {
          key: "ruolo",
          sortable: false,
        },
      ],
      items: [],
      loading: false,
    };
  },
  methods: {
    async getUsers() {
      this.loading = true;

      try {
        const { docs } = await UsersService.getUsers(this.$db);
        const users = docs.map((doc) => doc.data());

        this.items = users.map((user) => {
          return {
            utente: `${user.firstName} ${user.lastName}`,
            email: user.email,
            ruolo: user.role,
          };
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    handleAddedUser() {
      this.$root.$emit("bv::hide::modal", "add-user-modal");
      this.getUsers();
    },

    openAddUserDialog() {
      this.$root.$emit("bv::show::modal", "add-user-modal");
    },
  },
  mounted() {
    this.$store.dispatch("utils/setSectionName", "Utenti");

    this.getUsers();
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/settings/users/UsersPage.vue